import { Location } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'error-404',
    templateUrl: './error-404.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class Error404Component {
    /**
     * Constructor
     */
    constructor(
        private _location: Location
    ) {

    }

    goBack(){
        this._location.back();
    }
}
